import { computed, unref } from 'vue'
import { isFunction } from '@vue/shared'
import type { MaybeRef } from '@vueuse/core'

export type ReactiveParam<T> = MaybeRef<T> | (() => MaybeRef<T>)

/**
 * Use a reactive parameter.
 */
export function reactiveParam<T>(param: ReactiveParam<T>) {
    return computed(() => {
        return unref(isFunction(param) ? param() : param)
    })
}
